import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_app/settings/team-members_/$memberUserId/',
)({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/settings/team-members/$memberUserId/notifications',
            params,
        });
    },
});
